'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import I18n from 'I18n';
import Loadable from 'UIComponents/decorators/Loadable';
import { withViewContainerContext } from '../../../containers/ViewContainerContext';
const LoadableViewToolbarAddLogo = Loadable({
  loader: () => import(
  /* webpackChunkName: "view-secondary-content" */
  './ViewToolbarAddLogo')
});

const ViewToolbarLogo = ({
  logoUrl,
  companyName,
  logoAltText,
  context
}) => {
  let alt = logoAltText;

  if (!logoAltText) {
    if (companyName) {
      alt = I18n.text('a11y.brandingAltText', {
        companyName
      });
    } else {
      alt = I18n.text('a11y.brandingAltTextNoCompany');
    }
  }

  if (logoUrl) {
    return /*#__PURE__*/_jsx("div", {
      role: "banner",
      "aria-labelledby": "logo-landmark",
      children: /*#__PURE__*/_jsx("img", {
        id: "logo-landmark",
        src: logoUrl,
        style: {
          maxHeight: 40
        },
        alt: alt
      })
    });
  }

  if (context.isPreview && context.hasHigherDocumentsLimit()) {
    return /*#__PURE__*/_jsx(LoadableViewToolbarAddLogo, {});
  }

  return /*#__PURE__*/_jsx("div", {});
};

ViewToolbarLogo.propTypes = {
  logoUrl: PropTypes.string,
  logoAltText: PropTypes.string,
  companyName: PropTypes.string,
  context: PropTypes.shape({
    isPreview: PropTypes.bool.isRequired,
    hasHigherDocumentsLimit: PropTypes.func
  }).isRequired
};
export default withViewContainerContext(ViewToolbarLogo);